import { render } from "./SelfMediaTraining.vue?vue&type=template&id=d1ff31d8&scoped=true"
import script from "./SelfMediaTraining.vue?vue&type=script&lang=js"
export * from "./SelfMediaTraining.vue?vue&type=script&lang=js"

import "./SelfMediaTraining.vue?vue&type=style&index=0&id=d1ff31d8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1ff31d8"]])

export default __exports__